<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<!-- <app-revolution-slider5></app-revolution-slider5> -->
 <app-revolution-slider-cluster></app-revolution-slider-cluster>
<div class="main-content">
    <app-our-clients [pricingLink]="pricingLink"></app-our-clients>
    <!-- <app-about-us></app-about-us> -->
    <!-- <app-products></app-products> -->
     <app-our-services [List]="List" [titleSectionProp]="titleSectionProp"></app-our-services>
    <!-- <app-our-testimonial></app-our-testimonial> -->
    <!-- <app-our-clients></app-our-clients> -->
    <!-- <app-resources></app-resources> -->
    <!-- <app-get-started></app-get-started> -->
</div>
<app-footer></app-footer>
